<template>  
    <div class="result-controls">
        <div class="controls-top"> <!-- container 클래스 제거 -->
            <div class="result-info">
                <!-- 전체 체크박스 영역 -->
                <!-- <CheckboxAll :checkboxVisible="checkboxVisible"></CheckboxAll> -->
                <div><strong class="result-num">{{vuexTotalYescoinHistoryCnt}}개</strong>의 검색 결과</div>
            </div>
            <div class="position-relative" v-if="vuexTotalYescoinHistoryCnt != 0">
                <button @click.prevent="showFilterSelect" class="btn-filter-select mobile-only" aria-label="정렬 기준 선택"></button>
                <ul class="result-filter">
                    <li>
                        <button class="filter-item item__desc active" v-on:click="filterClick($event)">
                            최신순
                        </button>
                    </li>
                    <li>
                        <button class="filter-item item__asc" v-on:click="filterClick($event)">
                            과거순
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 모바일용 필터 셀렉트 옵션 영역 active 클래스 추가시 노출 -->
        <div role="dialog" class="controls-bottom mobile-toast-popup" :class="{active : activeHas}">
            <div class="opacity-bg" @click.prevent="closeResultFilter"></div>
            <div class="result-filter toast-layout">
                <div class="toast-name">정렬</div>
                <ul>
                    <li>
                        <button class="filter-item item__desc active" v-on:click="filterClick($event)">
                            최신순
                        </button>
                    </li>
                    <li>
                        <button class="filter-item item__asc" v-on:click="filterClick($event)">
                            과거순
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { eventBus } from '@/event/index.js';

export default {
    components: {
        // CheckboxAll: () => import('@/components/order-item/CheckboxAll.vue'),    // 전체 체크박스
    },

    props: { 
        checkboxVisible: {      // 전체 선택 체크박스 노출 여부
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            activeHas: false,
        }
    },

    created() {
    },

    mounted() {

    },

    computed: {
		...mapState({
            resultCnt: state => state.resultCnt,
            vuexTotalYescoinHistoryCnt: state => state.yescoinStore.vuexTotalYescoinHistoryCnt,
        }),	
	},

    methods: {

        //필터 변경 함수
        filterClick(event) {
            const element = event.currentTarget.className;

            const desc = document.querySelectorAll('.item__desc');
            const asc = document.querySelectorAll('.item__asc');

            if(element.includes('item__desc')) {            // 최신순

                desc[0].classList.add('active');
                desc[1].classList.add('active');

                asc[0].classList.remove('active');
                asc[1].classList.remove('active');

                eventBus.$emit('chkDateSort', 'DESC_DATE');

            } else if(element.includes('item__asc')) {      // 과거순

                asc[0].classList.add('active');
                asc[1].classList.add('active');

                desc[0].classList.remove('active');
                desc[1].classList.remove('active');

                eventBus.$emit('chkDateSort', 'ASC_DATE');
            }

            this.closeResultFilter();
        },

        // 모바일용 필터 선택시
        showFilterSelect() {
            this.activeHas = true;
        },
        
        // 정렬 필터 요소 외 외부영역 클릭 시
        closeResultFilter() {
            this.activeHas = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util/resultcontrol.scss';

</style>